const mainMenuData = {
  left: [
    {
      name: 'READY-TO-WEAR',
      url: `https://${process.env.SHOPIFY_DOMAIN}/collections/all-ready-to-wear`,
      children: []
    },
    {
      name: 'BRIDAL',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/bridal`,
      children: []
    },
    {
      name: 'BRIDESMAIDS',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/bridesmaids`,
      children: []
    }
  ],
  right: [
    {
      name: 'Store Locator',
      url: `https://${process.env.SHOPIFY_DOMAIN}/a/apps/store-location-finder`,
      children: []
    },
    {
      name: 'Book an Appointment',
      url: `${process.env.PROXY_PATH}/booking/onboarding`,
      children: []
    },
    {
      name: 'Trunk Shows',
      url: `https://${process.env.SHOPIFY_DOMAIN}/pages/trunk-shows`,
      children: null
    },
  ],
}

const subMenuData = [
  {
    name: 'New',
    url: `https://${process.env.SHOPIFY_DOMAIN}/collections/rtw-new`
  },
  {
    name: 'Shop',
    url: `https://${process.env.SHOPIFY_DOMAIN}/collections/all-ready-to-wear`
  },
  {
    name: 'Lookbook',
    url: `https://${process.env.SHOPIFY_DOMAIN}/pages/lookbook-pre-spring-2026`
  }
]

const mobileMenuData = {
  tabs: [
    {
      name: 'Ready-to-Wear',
      key: 'ready-to-wear',
      sections: [
        { name: 'New', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/new-rtw` },
        { name: 'Shop', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/all-ready-to-wear` },
        { name: 'Best Sellers', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/best-sellers` },
        { name: 'Wedding Guest', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/wedding-guest` },
        { name: 'Lookbook', url: `https://${process.env.SHOPIFY_DOMAIN}/pages/amsale-fall-2025-rtw-lookbook` },
      ],
    },
    {
      name: 'Bridal',
      key: 'bridal',
      sections: [
        { name: 'New', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/new-bridal` },
        { name: 'Shop', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/bridal` },
        { name: 'Second Look', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/second-look` },
        { name: 'Accessories', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/accessories` },
        { name: 'Custom', url: `https://${process.env.SHOPIFY_DOMAIN}/pages/amsale-custom-bridal` },
      ],
    },
    {
      name: 'Bridesmaids',
      key: 'bridesmaids',
      sections: [
        { name: 'New', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/new-bridesmaids` },
        { name: 'Shop', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/bridesmaids` },
        { name: 'Swatches', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/swatches` },
        { name: 'Mother Of', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/mother-of-the-bride` },
        { name: 'Amsale x You', url: `https://${process.env.SHOPIFY_DOMAIN}/collections/amsale_x_you_bridesmaids` },
        { name: 'Alterations', url: `https://${process.env.SHOPIFY_DOMAIN}/pages/alterations` },
      ],
    },
  ],
  bottomLinks: [
    { name: 'Store Locator', url: `https://${process.env.SHOPIFY_DOMAIN}/a/apps/store-location-finder` },
    { name: 'Trunk Shows', url: `https://${process.env.SHOPIFY_DOMAIN}/pages/trunk-shows` },
    { name: 'Account', url: `${process.env.PROXY_PATH}/profile/account` },

  ],
};

export { mainMenuData, mobileMenuData, subMenuData};
